import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import { H3Switch, H3Field } from 'h3-mobile-vue';
import { BaseControl } from "@cloudpivot/form/src/common/controls/base-control";
let InputLogic = class InputLogic extends BaseControl {
};
InputLogic = tslib_1.__decorate([
    Component({
        name: "input-logic",
        components: {
            H3Switch,
            H3Field
        }
    })
], InputLogic);
export default InputLogic;
